// utils
import axiosInstance from 'src/utils/axios';
// types
import {HOST_API} from "../config-global";
import creds from "./creds";

// ----------------------------------------------------------------------

export async function getCities(): Promise<{cities: {
    id: number,
    name: string,
    schools: {
      id: number,
      name: string,
    }[]
  }[]}> {
  return axiosInstance(`${HOST_API}/cities`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'x-session-id': await creds.data.getCookie(),
    },
  }).then(res => res.data);
}

export async function getGroupSchools(): Promise<{schools: {
    id: string,
    name: string,
  }[]}> {
  return axiosInstance(`${HOST_API}/group-schools`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'x-session-id': await creds.data.getCookie(),
    },
  }).then(res => res.data);
}
